import 'bootstrap/js/dist/modal';

(function($) {
    if ($('.video-modal__link').length > 0) {
        $('.video-modal__link').on('click', function(e) {
            e.preventDefault();
        });
    }

    $('.modal').on('hide.bs.modal', function() {
        const backupVideoClose = $(this).html();
        $(this).html(backupVideoClose);
    });
})(jQuery);
